import { render } from "./PlayerProfile.vue?vue&type=template&id=646d5d0f"
import script from "./PlayerProfile.vue?vue&type=script&lang=js"
export * from "./PlayerProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/PlayerProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "646d5d0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('646d5d0f', __exports__)) {
    api.reload('646d5d0f', __exports__)
  }
  
  module.hot.accept("./PlayerProfile.vue?vue&type=template&id=646d5d0f", () => {
    api.rerender('646d5d0f', render)
  })

}


export default __exports__